import React, { useCallback, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CustomModal, BackgroundIcon, Loader, Icon } from '@nile/components';
import styled from 'styled-components';
import { TicketClient } from '@nile/graphql';
import { GET_ORIGINAL_MESSAGE } from '@nile/graphql/src';
import { Page, Button } from '@superops/ui-design-system';
import dompurify from 'dompurify';
import { Times } from '@styled-icons/fa-solid';
import { SVGIcon } from '@superops/super-icons';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const MessageWrapper = styled.div`
  min-width: 1200px;
  max-width: 1200px;
  height: 90vh;

  .justify-between {
    justify-content: space-between;
  }
`;

const OriginalMessage = (props) => {
  const [sheetActive, setSheetActive] = useState(false);
  const { message } = props;
  const [loading, setLoading] = useState(false);
  const [originalContent, setOriginalContent] = useState(null);

  const toggleSheetActive = useCallback(async () => {
    setSheetActive((sheetActive) => !sheetActive);
    const GetConversationThreadedContentInput = {
      entityId: message.ticketId
    };

    setLoading(true);
    const response = await TicketClient.query({
      query: GET_ORIGINAL_MESSAGE,
      variables: {
        input: GetConversationThreadedContentInput
      },
      fetchPolicy: 'network-only'
    });
    setLoading(false);
    setOriginalContent(response?.data?.getTicketConversationThreadedContent);
  });

  const closeSheet = useCallback(() => {
    setSheetActive((sheetActive) => !sheetActive);
  });

  const stopEvents = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div onClick={stopEvents}>
      <div
        onClick={toggleSheetActive}
        className="flex g5 pointer"
        fullHeight={props.fullHeight}
      >
        <div className="flex">
          <SVGIcon name="MailSettings" />
        </div>

        <FormattedMessage id="ticket.details.chat.originalMessage" />
      </div>
      <CustomModal open={sheetActive} onClose={closeSheet}>
        <MessageWrapper>
          <Page
            variant="primary"
            contentHeight="120px"
            title={
              <FormattedMessage id="ticket.details.chat.originalMessage.heading" />
            }
            primaryAction={
              <Button
                onClick={() => {
                  closeSheet();
                }}
                plain
                icon={<SVGIcon name="Close" />}
              />
            }
          >
            {loading ? (
              <Loader />
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: dompurifier(originalContent)
                  }}
                />
              </>
            )}
          </Page>
        </MessageWrapper>
      </CustomModal>
    </div>
  );
};

export default injectIntl(OriginalMessage);
